import { GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { noop } from 'lodash';
import { createContext } from 'react';

export interface TableContextProps {
  readonly keepPagination?: boolean;
  readonly isMultiselect: boolean;
  readonly selectionModel: Map<GridRowId, GridValidRowModel>;
  readonly onClearSelection: () => void;
}

export const TableContext = createContext<TableContextProps>({
  isMultiselect: false,
  onClearSelection: noop,
  selectionModel: new Map(),
});
